"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
var Overlay;
(function (Overlay) {
    Overlay["Normal"] = "u-overlay";
    Overlay["Tint"] = "u-overlay-tint";
})(Overlay = exports.Overlay || (exports.Overlay = {}));
//# sourceMappingURL=Overlay.js.map